import styled, { css } from 'styled-components';
import { iconStyles, StyledIconWrapperTypes } from '../wrappers/styles';

export const Wrapper = styled.span<{ $status: StyledIconWrapperTypes; $size: number; $borderRadius: number }>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    width: ${({ $size }) => $size}px;
    height: ${({ $size }) => $size}px;
    border-radius: ${({ $borderRadius }) => $borderRadius}px;
    font-size: ${({ $size }) =>
        // Calculate the icon size relative to the size of the background element
        Math.round($size * (28 / 48))}px;

    ${({ $status }) => {
        const styleForStatus = iconStyles[$status];
        return css`
            background: ${styleForStatus.bg};
            color: ${styleForStatus.color};
        `;
    }}
`;
